import { Link } from "react-router-dom";
import { Archive, ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { PageIntro } from "../components/PageIntro";
import { FinalCTA } from "../components/FinalCTA";
import { EventRow } from "../components/EventRow";
import eventsData from "../data/events.json";
import { upcomingEvents } from "../lib/events";

export default function Events() {
  const { t, lang, pathFor } = useLang();
  const upcoming = upcomingEvents(eventsData.upcoming);

  return (
    <>
      <PageIntro overline={t("eventsPage.overline")} title={t("eventsPage.title")} testId="events-intro" />
      <section className="bg-cream pb-16" data-testid="events-upcoming">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <Reveal>
            <h2 className="mb-6 font-serif text-3xl text-charcoal">{t("eventsPage.upcoming")}</h2>
          </Reveal>
          <div className="border-t border-border">
            {upcoming.length ? upcoming.map((event, index) => (
              <Reveal key={event.id} delay={index * 0.04}>
                <EventRow event={event} lang={lang} ticketsLabel={t("eventsPage.tickets")} />
              </Reveal>
            )) : <p className="py-10 text-charcoal/50" data-testid="events-empty">{t("eventsPage.empty")}</p>}
          </div>
        </div>
      </section>
      <section className="bg-sand/30 py-16 lg:py-24" data-testid="events-archive-cta">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-6 sm:flex-row sm:items-end lg:px-10">
          <Reveal>
            <p className="font-serif text-3xl text-charcoal/80">{t("eventsPage.archiveTitle")}</p>
            <p className="mt-3 max-w-xl text-base leading-relaxed text-charcoal/65">{t("eventsPage.archiveBody")}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <Link to={pathFor("/events/past")} data-testid="past-events-link" className="inline-flex items-center gap-2 rounded-full border border-border px-6 py-3 text-sm font-semibold text-charcoal transition-colors hover:border-terracotta hover:text-terracotta">
              <Archive className="h-4 w-4" /> {t("eventsPage.archiveLink")} <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}